    angular.module('assets')
        .factory('AssetDocument', function ($resource) {
            return $resource('/crm/api/asset-document/:id/:method', {}, {
                list: {method: 'GET', isArray: false},
                get: {method: 'GET'},
                update: {method: 'PUT', params: {id: "@id"}},
                accept: {method: 'POST', params: {id: "@id", method: 'accept'}},
                revise: {method: 'POST', params: {id: "@id", method: 'revise'}},
                reviseNoAccept: {method: 'POST', params: {id: "@id", method: 'revise-no-accept'}},
                cancel: {method: 'POST', params: {id: "@id", method: 'cancel'}},
                remove: {method: 'DELETE'}
            });
        })
        .factory('AssetStorage', function ($resource) {
            return $resource('/crm/api/asset-storage', {}, {
                list: {method: 'GET', isArray: false}
            });
        })
        .service('AssetDocumentService', function ($rootScope, modals, AssetDocument) {
            this.addModal = options => {
                let entity = {
                    id: null,
                    issueDate: moment().format('YYYY-MM-DD'),
                    items: []
                };
                angular.extend(entity, options);
                return editModal(entity);
            };
            this.edit = id => {
                AssetDocument.get({id: id}).$promise.then(entity => editModal(entity));
            };
            this.revise = id => {
                AssetDocument.get({id: id}).$promise.then(entity => {
                    entity.revised = true;
                    editModal(entity);
                });
            };
            this.accept = id => {
                AssetDocument.get({id: id}).$promise.then(entity => modals.open('app/asset/document/accept-modal.html', 'AssetDocumentAcceptController', entity, {}, "$ctrl"));
            };
            this.cancel = id => {
                AssetDocument.get({id: id}).$promise.then(entity => modals.open('app/asset/document/cancel-modal.html', 'AssetDocumentCancelController', entity, {}, "$ctrl"));
            };
            this.show = id => {
                AssetDocument.get({id: id}).$promise.then(entity => modals.open('app/asset/document/show-modal.html', 'AssetDocumentShowModalController', entity, {size: 'lg'}, "$ctrl"));
            };
            this.isFinished = doc => doc !== null && (doc.status === 'CANCELLED' || doc.status === 'FINISHED');
            this.canCancel = doc => doc !== null && doc.status === 'WAITING';
            this.canAccept = doc => doc !== null && (doc.status === 'WAITING' || doc.status === 'IN_PROGRESS');
            this.canEdit = doc => doc !== null && doc.status === 'WAITING' && doc.revised === false;
            this.canRevise = doc => doc !== null && doc.status === 'WAITING';

            function editModal(entity) {
                return modals.open('app/asset/document/edit-modal.html', 'AssetDocumentDialogController', entity, {size: 'lg'}, "vm")
            }
        })
        .run(function (NavbarLeftMenu) {
            NavbarLeftMenu.add({
                authorities: "ROLE_ASSETS",
                path: "/asset-document",
                ico: "fa fa-fw fa-gears",
                name: 'asset-doc.menu',
                order: 87
            });
        })
        .config(function ($stateProvider) {
            $stateProvider.state('assetDocumentList', {
                parent: 'app',
                url: '/asset-document?{page:int}&{size:int}&sort&search&{project:int}&tag&status',
                data: {
                    authorities: ['ROLE_ASSETS']
                },
                views: {
                    'content@': 'assetDocumentList'
                },
                resolve: {
                    filters: ($stateParams) => angular.copy($stateParams),
                    page: (AssetDocument, $stateParams) => AssetDocument.list(angular.copy($stateParams)).$promise
                }
            });
            $stateProvider.state('assetDocument', {
                parent: 'app',
                url: '/asset-document/{id}',
                data: {
                    authorities: ['ROLE_ASSETS']
                },
                views: {
                    'content@': 'assetDocumentShow'
                },
                resolve: {
                    item: (AssetDocument, $stateParams) => AssetDocument.get({id: $stateParams.id}).$promise.then(result => result)
                }
            });
        });
